export default {
    bucketListType: {
        custom: "star",
        country: "public",
        region: "map",
        city: "location_city",
        place: "location_on",
    },
    impression: {
        0: "more_horiz",
        1: "sentiment_dissatisfied",
        2: "sentiment_neutral",
        3: "sentiment_satisfied",
        4: "mood",
        5: "favorite",
    },
    impressionEmoji: {
        0: "🤔",
        1: "☹️",
        2: "😐",
        3: "🙂",
        4: "😀",
        5: "❤️",
    },
    privacy: {
        personal: "visibility_off",
        everyone: "visibility",
    },
    transport: {
        plane: "flight",
        train: "train",
        car: "directions_car",
        "rented-car": "directions_car",
        bus: "directions_bus",
        ship: "directions_boat",
        ferry: "directions_boat",
        boat: "sailing",
        minivan: "airport_shuttle",
        taxi: "local_taxi",
        bike: "directions_bike",
        walking: "directions_walk",
    },
};
